import React from 'react';
import styles from './style.module.css';

export default () => (
    <div className={styles.page}>
        <div className={styles.contentContainer}>
            <h1 className={styles.mainTitle}>Thank you!</h1>
            <p className={styles.text}>A Libro Coach will be in touch with you soon. We’re excited to help you with the purchase of your new home.</p>
            <a href='https://www.libro.ca/buying-house' className={styles.button} title='Learn More about Buying a Home'>Learn More about Buying a Home</a>
        </div>
    </div>
);
